import {
	Component,
	ElementRef,
	EventEmitter,
	Inject,
	Input,
	OnChanges,
	Output,
	SimpleChanges,
	ViewChild,
	forwardRef
} from '@angular/core';

import { VbRadioGroupBtnComponent } from './VbRadioGroupBtn.Component';

import styles from './VbRadioBtn.Component.module.less';

/**
 * Radio Button common component.
 * usage -
 * <vb-radio-group-btn>
 * 	<vb-radio-btn
			[name]="'radio'"
			[vbUiRadioBtn]="'radio1'"
			[(ngModel)]="buttonValue">
			Radio 1
		</vb-radio-btn>
		<vb-radio-btn
			[name]="'radio'"
			[vbUiRadioBtn]="'radio2'"
			[(ngModel)]="buttonValue">
			Radio 2
* 	</vb-radio-btn>
* </<vb-radio-group-btn>
 */
@Component({
	selector: 'vb-radio-btn',
	templateUrl: './VbRadioBtn.Component.html',
	host: {
		'class': 'box-block'
	},
	standalone: false
})
export class VbRadioBtnComponent implements OnChanges {
	@Input() public accessibilityLabel: string;
	@Input() public name: string; // Group of buttons should share the same name. Used by the underlying native radio component for nav within the group.
	@Input() public optionValue: string;
	@Input() public autoFocus: boolean;
	@Input() public disableTabFocus: boolean;

	@Output() public changed: EventEmitter<VbRadioBtnComponent> = new EventEmitter<VbRadioBtnComponent>();
	@ViewChild('wrapperLabel', { static: true })
	public wrapperLabel: ElementRef;

	public readonly styles = styles;
	public checked: boolean;

	constructor(
		@Inject(forwardRef(() => VbRadioGroupBtnComponent)) private readonly parent: VbRadioGroupBtnComponent
	){}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.autoFocus && this.autoFocus) {
			this.setAutoFocus();
		}
	}

	public onChangeInternal(event?: Event): void {
		event?.stopPropagation();
		this.parent.onOptionSelect(this);
	}

	public setAutoFocus(): void {
		this.wrapperLabel?.nativeElement?.focus();
	}
}
